// omz.ae — the partner enquiry form (owner 2026-10-07). Not an account: the
// details go to the OMZ Hub's /api/signup, which emails them to the OMZ admin
// inbox. On the Firebase site it is same-origin (the site's rewrite); in the
// Shopify theme (site-shopify/) the form names the Hub in data-endpoint.
"use strict";

// Shopify's password page: the store's own password box stays out of sight
// until the owner opens omz.ae/password#enter (or a wrong password came back)
(function () {
  const enter = document.querySelector("[data-enter]");
  const show = () => { if (enter && location.hash === "#enter") { enter.setAttribute("data-open", ""); const i = enter.querySelector("input[type=password]"); if (i) i.focus(); } };
  show(); window.addEventListener("hashchange", show);
})();

(function () {
  const form = document.getElementById("pf");
  if (!form) return;
  const $ = (id) => document.getElementById(id);
  const fields = { business: $("pf-business"), name: $("pf-name"), phone: $("pf-phone"), email: $("pf-email") };
  const tiles = Array.from(form.querySelectorAll(".tile"));
  const submit = form.querySelector(".submit");
  const fail = $("pf-fail");
  const endpoint = form.dataset.endpoint || "/api/signup";

  function setError(key, text) {
    const el = $(`pf-${key}-err`);
    if (el) el.textContent = text || "";
    if (fields[key]) fields[key].setAttribute("aria-invalid", text ? "true" : "false");
  }
  Object.keys(fields).forEach((k) => fields[k].addEventListener("input", () => setError(k, "")));
  tiles.forEach((t) => t.addEventListener("click", () => {
    t.setAttribute("aria-pressed", t.getAttribute("aria-pressed") === "true" ? "false" : "true");
    setError("category", "");
  }));

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (submit.disabled) return;
    const v = {
      business: fields.business.value.trim(), name: fields.name.value.trim(),
      phone: fields.phone.value.trim(), email: fields.email.value.trim(),
      categories: tiles.filter((t) => t.getAttribute("aria-pressed") === "true").map((t) => t.dataset.cat),
    };
    const er = {};
    if (!v.business) er.business = "Enter your business name.";
    if (!v.name) er.name = "Enter your name.";
    if (v.phone.replace(/\D/g, "").length < 7) er.phone = "Enter a valid mobile number.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) er.email = "Enter a valid email address.";
    if (!v.categories.length) er.category = "Select at least one.";
    ["business", "name", "phone", "email", "category"].forEach((k) => setError(k, er[k]));
    fail.hidden = true;
    if (Object.keys(er).length) {
      const first = ["business", "name", "phone", "email"].find((k) => er[k]);
      if (first) fields[first].focus(); else if (tiles[0]) tiles[0].focus();
      return;
    }

    submit.disabled = true;
    submit.textContent = "Sending…";
    try {
      const r = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          source: "omz.ae", business_name: v.business, contact_name: v.name, mobile: v.phone, email: v.email,
          categories: v.categories, website: form.elements.website ? form.elements.website.value : "",
        }),
      });
      let data = {};
      try { data = await r.json(); } catch (_) { data = {}; }
      if (!r.ok) throw new Error(data.error || "We could not send your details right now. Please try again.");
      form.hidden = true;
      const thanks = $("pf-thanks");
      thanks.hidden = false;
      thanks.focus();
    } catch (err) {
      // a dropped connection says "Failed to fetch": the visitor gets plain words
      const offline = err instanceof TypeError;
      fail.textContent = (!offline && err && err.message) || "We could not send your details right now. Check your connection and try again.";
      fail.hidden = false;
      submit.disabled = false;
      submit.textContent = "Become a Partner";
    }
  });
})();
